(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const pagination = document.querySelector('.AjaxinatePagination');
  const loopContainer = document.querySelector('.AjaxinateLoop');
  const collectionHandle = window.location.pathname.split('/').pop(); // e.g., 'alljacket'
  
  // Step 1: Clear sessionStorage on fresh visit (not browser back)
  const navType = performance.getEntriesByType("navigation")[0]?.type;
  if (navType === "navigate") {
    sessionStorage.removeItem("collState");
  }

  // Step 2: Setup Ajaxinate
  if (pagination) {
    const method = pagination.getAttribute('data-pagination') === 'scroll' ? 'scroll' : 'click';
   const state = JSON.parse(sessionStorage.getItem("collState") || "{}");

// Set pagesLoaded depending on state
let pagesLoaded = (state.handle === collectionHandle && state.pagesLoaded)
  ? state.pagesLoaded
  : 1;
console.log("dek dekh pages loaded:", pagesLoaded);
let isRestoring = false;
let loaded = 1;

const stored = JSON.parse(sessionStorage.getItem("collState") || '{}');
if (stored.handle === collectionHandle && stored.pagesLoaded > 1) {
  isRestoring = true;
  console.log('dekh dekh:', stored);

  const loader = setInterval(() => {
    const btn = document.querySelector('.AjaxinatePagination a');
    console.log('dekh dekh:', btn);

    if (btn && loaded < stored.pagesLoaded) {
      console.log('dekh dekh pages loaded!!', loaded)
      btn.click();
      loaded++;
    } else {
      clearInterval(loader);

      if (stored.scrollY) {
        console.log('dekh dekh:', "scroll hor abhai");
 window.scrollTo(0, stored.scrollY);
          isRestoring = false;
      } else {
        // ✅ If there's no scrollY, restore ends here
        isRestoring = false;
      }
    }
  }, 700);
}

const ajaxinate = new Ajaxinate({
  container: '.AjaxinateLoop',
  pagination: '.AjaxinatePagination',
  loadingText: '<span class="loader-line"></span>',
  method: method,
  callback: function () {
    // 🛑 Don't count callback during restore
    console.log('dekh chalra hai ye')
    // if (isRestoring) return;
 if (isRestoring) return; // ✅ skip callback logic during restore
    console.log('dekh dekio ',   pagesLoaded)

    pagesLoaded++;
    const scrollY = window.scrollY;
    const currentState = JSON.parse(sessionStorage.getItem("collState") || "{}");

const state = {
  handle: collectionHandle,
  scrollY: currentState.scrollY !== undefined ? currentState.scrollY : window.scrollY,
  pagesLoaded: pagesLoaded
};
     

    // Only proceed if there's already a stored state
    sessionStorage.setItem("collState", JSON.stringify(state));
  }
});

    let timeout;
window.addEventListener('scroll', function () {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    const currentState = JSON.parse(sessionStorage.getItem("collState") || "{}");

    // Only proceed if there's already a stored state
    if (currentState && currentState.handle) {
      currentState.scrollY = window.scrollY;
      console.log('dekh dekh',  currentState.scrollY)
      sessionStorage.setItem("collState", JSON.stringify(currentState));
      console.log('dekh dekh after seetting bitch',  currentState.scrollY)
    }
  }, 200); // Update scrollY only after scroll settles
});


    // Step 4: Save on product link click
    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      link.addEventListener('click', () => {
      
        const state = {
          handle: collectionHandle,
          scrollY: window.scrollY,
          pagesLoaded: pagesLoaded
        };
          console.log('dekh dekh link pe click:',state)
        sessionStorage.setItem("collState", JSON.stringify(state));
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (typeof Shopify !== "undefined" && Shopify.country === "IN") {
    return; // Indian customers → leave INR prices as-is
  }
const el = document.querySelector(".js-product-price");
if (el) {
  const paise = parseInt(el.dataset.inr, 10);
  const inrValue = paise / 100;
  const symbol = window.CurrencyUtils.getSymbol();
  const converted = window.CurrencyUtils.convert(inrValue);
  el.textContent = `${symbol}${converted}`;
  console.log("Raw paise:", paise);   // e.g. 519900
  console.log("INR value:", inrValue); // e.g. 5199
}
});
var initPhotoSwipeFromDOM = function(gallerySelector) {
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;
  for (var i = 0; i < numNodes; i++) {
    figureEl = thumbElements[i]; // <figure> element
    if (figureEl.nodeType !== 1) {
      continue;
    }
    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };
    if (figureEl.children.length > 1) {
      item.title = figureEl.children[1].innerHTML;
    }
    if (linkEl.children.length > 0) {
      item.msrc = linkEl.children[0].getAttribute('src');
    }
    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }
  return items;
};
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;
  var eTarget = e.target || e.srcElement;
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });
  if (!clickedListItem) {
    return;
  }
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;
  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }
    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }
  if (index >= 0) {
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};
  if (hash.length < 5) {
    return params;
  }
  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }
  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }
  return params;
};
var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;
  items = parseThumbnailElements(galleryElement);
  options = {
    maxSpreadZoom: 1,
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),
  };
  if (fromURL) {
    if (options.galleryPIDs) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }
  if (isNaN(options.index)) {
    return;
  }
  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};
var galleryElements = document.querySelectorAll(gallerySelector);
for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};
initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();
})();
